module.exports = __webpack_public_path__ + "img/illustration-1.32c2fa4a.svg";